import { cn } from "app/lib/utils"
import type { PlayerChipVariant } from "./PlayerPlaytime"

type Props = {
  label1?: string | null
  label2?: string | null
  className?: string
  variant?: PlayerChipVariant
}

const slideTitleBaseClassName =
  "flex items-center gap-2.5 rounded-full px-[22px] py-3 text-lg font-semibold whitespace-nowrap text-white uppercase"

const slideTitleVariantClassName: Record<PlayerChipVariant, string> = {
  dark: "bg-neutraal-opacity-950-65 backdrop-blur-[7.5px]",
  light:
    "bg-white/40 backdrop-blur-[4px] [text-shadow:0_0_2px_rgba(0,0,0,0.25)]",
}

export default function PlayerSlideTitle({
  label1,
  label2,
  className,
  variant = "dark",
}: Props) {
  if (!label1 && !label2) {
    return <div></div>
  }
  return (
    <div
      className={cn(
        slideTitleBaseClassName,
        slideTitleVariantClassName[variant],
        className
      )}
    >
      {label1 ? <span>{label1}</span> : null}
      {label1 && label2 ? <span>-</span> : null}
      {label2 ? <span>{label2}</span> : null}
    </div>
  )
}
